import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import "./modal.css";

const Modal = ({ isOpen, onClose, children }) => {
    useEffect(() => {
        if (!isOpen) return;

        const modalState = { modalOpen: true };

        window.history.pushState(modalState, "");

        const handlePopState = (event) => {
            if (event.state?.modalOpen) {
                onClose();
                return;
            }

            onClose();
        };

        window.addEventListener("popstate", handlePopState);

        return () => {
            window.removeEventListener("popstate", handlePopState);
        };
    }, [isOpen, onClose]);

    if (!isOpen) return null;

    const handleClose = () => {
        onClose();

        if (window.history.state?.modalOpen) {
            window.history.back();
        }
    };

    return ReactDOM.createPortal(
        <div className="modal-overlay" onClick={handleClose}>
            <div className="modal" onClick={(e) => e.stopPropagation()}>
                <button className="modal-close" onClick={handleClose}>
                    ×
                </button>
                {children}
            </div>
        </div>,
        document.body
    );
};

export default Modal;